import React, { useState } from 'react';
import { Transition } from '@headlessui/react';
import { useLocation } from 'react-router-dom';
import Button from '../elements/Button';
import BrandIcon from './BrandIcon';

export default function Header() {
  const [isCollapse, setIsCollapse] = useState(false);
  const location = useLocation();
  const path = location.pathname;
  const menuItems = ['Home', 'Team', 'Diensten', 'Contact'];
  const paths = ['/', '/team', '/services', '/discuss-project'];

  const handleMenuClick = () => {
    setIsCollapse(false);
  };

  return (
    <header className="bg-transparent text-white py-4 px-6 relative z-50">
      <div className="container mx-auto flex justify-between items-center">
        <div className="max-w-[70%]">
          <BrandIcon />
        </div>

        <button
          type="button"
          className="block lg:hidden focus:outline-none z-50"
          onClick={() => setIsCollapse(!isCollapse)}
        >
          <svg
            className="w-8 h-8 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke="currentColor"
          >
            <path
              className={!isCollapse ? 'block' : 'hidden'}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
            <path
              className={isCollapse ? 'block' : 'hidden'}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <nav className="hidden lg:flex items-center gap-6 font-semibold">
          {paths.map((itemPath, index) => (
            <Button
              key={itemPath}
              href={itemPath}
              type="link"
              className={`hover:text-gray-300 transition ${
                path === itemPath ? 'underline' : ''
              }`}
            >
              {menuItems[index]}
            </Button>
          ))}
        </nav>
      </div>

      {/* Mobile menu */}
      <Transition
        show={isCollapse}
        enter="transition duration-300 ease-out"
        enterFrom="opacity-0 -translate-y-2"
        enterTo="opacity-100 translate-y-0"
        leave="transition duration-200 ease-in"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 -translate-y-2"
      >
        <nav className="lg:hidden absolute top-full left-0 w-full bg-[#252541] shadow-lg rounded-b-lg py-4 px-6">
          {paths.map((itemPath, index) => (
            <Button
              key={itemPath}
              href={itemPath}
              type="link"
              onClick={handleMenuClick}
              className={`block py-2 text-center text-lg hover:text-gray-400 transition ${
                path === itemPath ? 'underline' : ''
              }`}
            >
              {menuItems[index]}
            </Button>
          ))}
        </nav>
      </Transition>
    </header>
  );
}
